import {
  APP_MODULES,
  BUID,
  CAMPAIGN_TYPE,
  ENTRY_DATA_SOURCE,
  INTERSTITIAL_EXPIRATION_TYPE,
  INTERSTITIAL_TYPE_ID,
  MC_ENTRY_SOURCE,
  ONLINE_PRODUCTS,
  PAM_GAME_ID,
  PUSH_RETRY_TYPE,
  SENDER_NAME,
  TEMPLATE_CATEGORY,
  TOAST_TYPE,
  WEB_PUSH_PROJECT_CATEGORY,
  WEB_PUSH_PROJECT_GAME_ID,
} from './constants.js';

export const MC_ENTRY_SOURCE_SHORT_NAME_MAPPER = {
  [MC_ENTRY_SOURCE.JOURNEY_ENTRY_SOURCE]: 'JR',
  [MC_ENTRY_SOURCE.DATA_EXTENSION]: 'DE',
};

export const MC_ENTRY_SOURCE_TO_TEXT_MAPPER = {
  [MC_ENTRY_SOURCE.JOURNEY_ENTRY_SOURCE]: 'Journey Entry Source',
  [MC_ENTRY_SOURCE.DATA_EXTENSION]: 'Data Extension',
  [MC_ENTRY_SOURCE.MANUAL]: 'Manual',
};

export const CAMPAIGN_TYPE_TO_SENDERS_MAPPER = {
  [CAMPAIGN_TYPE.ONLINE]: [SENDER_NAME.OPAP_ONLINE, SENDER_NAME.PS_GR],
  [CAMPAIGN_TYPE.RETAIL]: [SENDER_NAME.OPAP_STORE, SENDER_NAME.OPAP_RETAIL, SENDER_NAME.OPAPREWARDS],
  [CAMPAIGN_TYPE.VLT]: [SENDER_NAME.OPAP_PLAY],
  [CAMPAIGN_TYPE.NEWSLETTER]: [SENDER_NAME.OPAP],
};

export const CAMPAIGN_TYPE_TO_DEFAULT_SENDER_MAPPER = {
  [CAMPAIGN_TYPE.ONLINE]: SENDER_NAME.OPAP_ONLINE,
  [CAMPAIGN_TYPE.RETAIL]: SENDER_NAME.OPAP_STORE,
  [CAMPAIGN_TYPE.VLT]: SENDER_NAME.OPAP_PLAY,
  [CAMPAIGN_TYPE.NEWSLETTER]: SENDER_NAME.OPAP,
};

export const ONLINE_PRODUCT_TYPE_TO_SENDER_MAPPER = {
  [ONLINE_PRODUCTS.TZOKER]: SENDER_NAME.OPAP_ONLINE,
  [ONLINE_PRODUCTS.KINO]: SENDER_NAME.OPAP_ONLINE,
  [ONLINE_PRODUCTS.LOTTO]: SENDER_NAME.OPAP_ONLINE,
  [ONLINE_PRODUCTS.PROTO]: SENDER_NAME.OPAP_ONLINE,
  [ONLINE_PRODUCTS.SUPER3]: SENDER_NAME.OPAP_ONLINE,
  [ONLINE_PRODUCTS.SB]: SENDER_NAME.PS_GR,
  [ONLINE_PRODUCTS.CASINO]: SENDER_NAME.PS_GR,
  [ONLINE_PRODUCTS.ALL]: SENDER_NAME.OPAP,
};

export const ENTRY_DATA_SOURCE_TO_TEXT_MAPPER = {
  [ENTRY_DATA_SOURCE.MC_DATA]: 'MC Data',
  [ENTRY_DATA_SOURCE.SF_DATA]: 'SF Data As Entry Source',
  [ENTRY_DATA_SOURCE.EVENT_DATA]: 'Event Data',
};

export const WEB_PUSH_PROJECT_GAME_ID_TO_CATEGORY_MAPPER = {
  [WEB_PUSH_PROJECT_GAME_ID.SB]: 'sb',
  [WEB_PUSH_PROJECT_GAME_ID.CASINO]: 'casino',
  [WEB_PUSH_PROJECT_GAME_ID.LOTTERY]: 'lottery',
};

export const WEB_PUSH_PROJECT_CATEGORY_TO_GAME_ID_MAPPER = {
  [WEB_PUSH_PROJECT_CATEGORY.SB]: 'SB',
  [WEB_PUSH_PROJECT_CATEGORY.CASINO]: 'CASINO',
  [WEB_PUSH_PROJECT_CATEGORY.LOTTERY]: 'LOTTERY',
};

export const BUID_TO_CAMPAIGN_TYPE_MAPPER = {
  [BUID.UAT]: [CAMPAIGN_TYPE.ONLINE, CAMPAIGN_TYPE.RETAIL, CAMPAIGN_TYPE.VLT, CAMPAIGN_TYPE.NEWSLETTER],
  [BUID.ONLINE_PROD]: [CAMPAIGN_TYPE.ONLINE],
  [BUID.RETAIL_PROD]: [CAMPAIGN_TYPE.RETAIL, CAMPAIGN_TYPE.NEWSLETTER],
  [BUID.VLT_PROD]: [CAMPAIGN_TYPE.VLT],
};

export const PAM_GAME_ID_TO_GAME_NAME_MAPPER = {
  [PAM_GAME_ID.PAME_STOIXIMA]: 'SB',
  [PAM_GAME_ID.CASINO]: 'CASINO',
  [PAM_GAME_ID.OPAP_ONLINE]: 'OPAPONLINE',
  [PAM_GAME_ID.NEPS]: 'NEPs',
};

export const INTERSTITIAL_TYPE_ID_TO_TEXT_MAPPER = {
  [INTERSTITIAL_TYPE_ID.TEXT_ONLY]: 'Text Only',
  [INTERSTITIAL_TYPE_ID.RICH]: 'Rich',
};

export const APP_MODULE_TO_TOKEN_MAPPER = {
  [APP_MODULES.SMS]: window.MESSAGE_GATEWAY_CONFIG?.varible,
  [APP_MODULES.WEB_PUSH]: window.MESSAGE_GATEWAY_CONFIG?.varible,
  [APP_MODULES.INTERSTITIAL]: window.MESSAGE_GATEWAY_CONFIG?.interstitialVarible,
  [APP_MODULES.NATIVE_PUSH]: window.MESSAGE_GATEWAY_CONFIG?.varible,
};

export const INTERSTITIAL_EXPIRATION_TYPE_MAPPER = {
  [INTERSTITIAL_EXPIRATION_TYPE.DATE]: 'Date',
  [INTERSTITIAL_EXPIRATION_TYPE.IN_DAYS]: 'In Days',
  [INTERSTITIAL_EXPIRATION_TYPE.IN_HOURS]: 'In Hours',
};

export const APP_MODULE_TO_TEXT_MAPPER = {
  [APP_MODULES.SMS]: 'SMS',
  [APP_MODULES.WEB_PUSH]: 'Web Push',
  [APP_MODULES.INTERSTITIAL]: 'Interstitial',
  [APP_MODULES.NATIVE_PUSH]: 'Native Push',
};

export const APP_MODULE_TO_TEMPLATE_CATEGORY_LIST_MAPPER = {
  [APP_MODULES.SMS]: [
    TEMPLATE_CATEGORY.ONLINE,
    TEMPLATE_CATEGORY.RETAIL,
    TEMPLATE_CATEGORY.VLT,
    TEMPLATE_CATEGORY.NEWSLETTER,
  ],
  [APP_MODULES.WEB_PUSH]: [TEMPLATE_CATEGORY.WEB_PUSH],
  [APP_MODULES.INTERSTITIAL]: [TEMPLATE_CATEGORY.INTERSTITIAL],
  [APP_MODULES.NATIVE_PUSH]: [TEMPLATE_CATEGORY.NATIVE_PUSH],
};

export const TEMPLATE_CATEGORY_TO_TEXT_MAPPER = {
  [TEMPLATE_CATEGORY.ONLINE]: 'Online',
  [TEMPLATE_CATEGORY.RETAIL]: 'Retail',
  [TEMPLATE_CATEGORY.VLT]: 'VLT',
  [TEMPLATE_CATEGORY.NEWSLETTER]: 'Newsletter',
  [TEMPLATE_CATEGORY.WEB_PUSH]: 'Web Push',
  [TEMPLATE_CATEGORY.INTERSTITIAL]: 'Interstitial',
  [TEMPLATE_CATEGORY.NATIVE_PUSH]: 'Native Push',
};

export const TOAST_TYPE_TO_BG_CLASS_MAPPER = {
  [TOAST_TYPE.SUCCESS]: 'text-bg-success',
  [TOAST_TYPE.INFO]: 'text-bg-info',
  [TOAST_TYPE.WARNING]: 'text-bg-warning',
  [TOAST_TYPE.DANGER]: 'text-bg-danger',
};

export const APP_MODULE_TO_FEATURE_FLAG_MAPPER = {
  [APP_MODULES.SMS]: 'SMS',
  [APP_MODULES.WEB_PUSH]: 'WEB_PUSH',
  [APP_MODULES.INTERSTITIAL]: 'INTERSTITIAL',
  [APP_MODULES.NATIVE_PUSH]: 'NATIVE_PUSH',
};

export const CAMPAIGN_TYPE_TO_ENTRY_DATA_SOURCE_MAPPER = {
  [CAMPAIGN_TYPE.ONLINE]: [ENTRY_DATA_SOURCE.MC_DATA, ENTRY_DATA_SOURCE.SF_DATA],
  [CAMPAIGN_TYPE.RETAIL]: [ENTRY_DATA_SOURCE.MC_DATA, ENTRY_DATA_SOURCE.EVENT_DATA],
  [CAMPAIGN_TYPE.VLT]: [ENTRY_DATA_SOURCE.MC_DATA, ENTRY_DATA_SOURCE.SF_DATA],
};

export const PUSH_RETRY_TYPE_TO_TEXT_MAPPER = {
  [PUSH_RETRY_TYPE.RETRY_FOR]: 'Retry For',
  [PUSH_RETRY_TYPE.RETRY_UNTIL]: 'Retry Until',
};
